import { render, staticRenderFns } from "./IconFilialFranchise.vue?vue&type=template&id=5cb40d78&scoped=true&"
import script from "./IconFilialFranchise.vue?vue&type=script&lang=js&"
export * from "./IconFilialFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb40d78",
  null
  
)

export default component.exports